import React from 'react';
import { Select as AntdSelect } from 'antd';
import { SelectProps } from 'antd/lib/select';

const SelectComponent: React.FC<SelectProps> = (props: SelectProps) => {
    const { value, ...rest } = props;

    return (
        <AntdSelect
            {...rest}
            value={value || undefined} // Antd Select treats empty string as valid value
        />
    );
};

export { SelectComponent };
